import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Marker, Geometry } from '@realpage-da/ng-map';

import { MapGridComponent, GridBaseComponent } from '~/shared/components/grids';
import { PropertyDetailJSON } from '~/core/model';
import { PropertyService } from '~/core/services';
import { PropertyGridComponent } from './property.grid';
import { PropertyTooltipComponent, PropertyMarkerComponent } from '../map';

@Component({
  selector: 'property-map-grid',
  template: `<property-grid #grid [properties]="properties"></property-grid>`,
  styles: []
})
export class PropertyMapGridComponent extends MapGridComponent<PropertyGridComponent> implements OnInit {
  properties: Observable<PropertyDetailJSON[]>;
  markers: Observable<Marker<number, PropertyDetailJSON>[]>;

  selectedPropertyIdForMap: number;
  selectedPropertyIdForGrid: number;

  constructor(private propertyService: PropertyService) {
    super();
  }

  select(id: number) {
    if (this.properties) this.properties
      .take(1)
      .subscribe(() => setTimeout(() => this.grid.selectRow(id)));

    else this.selectedPropertyIdForGrid = id;

    if (this.markers) this.markers
      .take(1)
      .subscribe(() => setTimeout(() => this.map.map.addTooltip(this.map.map.findFeature(id))));

    else this.selectedPropertyIdForMap = id;
  }

  ngOnInit() {
    this.properties = this.map.boundsChanged
      .auditTime(250)
      .takeUntil(this.onDestroy)
      .do(() => this.grid.grid.showLoadingIcon())
      .switchMap(bounds => this.propertyService.getProperties(bounds))
      .do(data => {
        data.sort((a, b) => {
          if (!a || !a.propertyName) return 1;
          if (!b || !b.propertyName) return -1;

          return a.propertyName <= b.propertyName ? -1 : 1;
        });
      })
      .share();

    if (this.selectedPropertyIdForGrid) {
      this.properties
        .take(1)
        .subscribe(() => setTimeout(() => {
          this.grid.selectRow(this.selectedPropertyIdForGrid);
          this.selectedPropertyIdForGrid = null;
        }));
    }

    this.markers = this.properties
      .map(properties => properties.map(property => ({
        id: +property.propertyId,
        geometry: new Geometry.Point(+property.latitude, +property.longitude),
        data: property,
        options: {
          icon: {
            component: PropertyMarkerComponent
          },
          tooltip: PropertyTooltipComponent
        }
      })))
      .share();

    if (this.selectedPropertyIdForMap) {
      this.markers
        .take(1)
        .subscribe(() => setTimeout(() => {
          this.map.map.addTooltip(this.map.map.findFeature(this.selectedPropertyIdForMap));
          this.selectedPropertyIdForMap = null;
        }));
    }
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.markers
      .takeUntil(this.onDestroy)
      .subscribe(
      markers => this.map.map.setMarkers(markers),
      error => console.error(error),
      () => this.map.map.setMarkers([]));
  }
}



// WEBPACK FOOTER //
// ./src/app/features/property/components/grids/property.map-grid.ts